// src/constants/dashboardConfig.js
import {
  faClipboardList,
  faDolly,
  faExclamationTriangle,
  faTools,
  faWrench,
  faClock,
  faTruck,
  faBoxOpen,
  faUsers,
  faFileContract,
  faFileInvoice,
} from '@fortawesome/free-solid-svg-icons'

export const dashboardConfig = {
  // ==========================================
  // ALMOXARIFADO (Módulo próprio, view única)
  // ==========================================
  almoxarifado: {
    padrao: {
      title: 'Visão Geral - Almoxarifado',
      listRoute: '/aluguel/movimentos',
      actionRoute: '/aluguel/movimentos',
      emptyMessage: 'Nenhuma requisição pendente no momento!',
      columns: [
        'OS',
        'Contrato',
        'Cliente',
        'Organização',
        'Tipo',
        'Data de Criação',
        'Prazo',
        'Situação',
      ],
      tableKey: 'pending_orders', // ⬅️ Adicionado para consistência
      cards: [
        {
          key: 'pending_requests',
          title: 'Requisições a Atender',
          icon: faClipboardList,
          color: 'warning',
        },
        {
          key: 'low_stock_products',
          title: 'Estoque Mínimo',
          icon: faExclamationTriangle,
          color: 'info',
        },
        {
          key: 'zero_stock_products',
          title: 'Estoque Zerado',
          icon: faBoxOpen,
          color: 'danger',
        },
      ],
    },
  },

  // ==========================================
  // MANUTENÇÃO (Módulo próprio, view única)
  // ==========================================
  manutencao: {
    gestor: {
      title: 'Upgrades e downgrades aguardando atendimento', listRoute: '/manutencao', actionRoute: '/manutencao',
      emptyMessage: 'Nenhum upgrade/downgrade aguardando atendimento.',
      columns: ['Equipamento', 'Tipo', 'Detalhes', 'Solicitado em'], tableKey: 'administrative_approvals',
      cards: [
        { key: 'pending_upgrades', title: 'Upgrades/downgrades pendentes', icon: faTools, color: 'info' },
      ],
    },
    padrao: {
      title: 'Equipamentos em garantia',
      listRoute: '/manutencao',
      actionRoute: '/manutencao',
      emptyMessage: 'Nenhum equipamento está em garantia no momento.',
      columns: ['Tombo', 'Equipamento', 'Retorno previsto', 'Dias restantes'],
      tableKey: 'warranty_items',
      cards: [
        {
          key: 'pending_maintenances',
          title: 'Manutenções pendentes',
          icon: faWrench,
          color: 'warning',
        },
        {
          key: 'warranty_expiring_soon',
          title: 'Garantias a vencer (7 dias)',
          icon: faClock,
          color: 'danger',
        },
      ],
    },
  },

  // ==========================================
  // ALUGUEL (Módulo compartilhado com múltiplas views)
  // ==========================================
  aluguel: {
    gestor: {
      title: 'Excedentes de contrato aguardando aprovação', listRoute: '/aluguel/requisicoes', actionRoute: '/aluguel/requisicoes',
      emptyMessage: 'Nenhum excedente de contrato aguardando aprovação.', columns: ['Equipamento', 'Tipo', 'Detalhes', 'Solicitado em'], tableKey: 'administrative_approvals',
      cards: [
        { key: 'pending_exchanges', title: 'Excedentes de contrato pendentes', icon: faClipboardList, color: 'info' },
      ],
    },
    // 1. Visão Padrão (Fallback para roles não mapeadas)
    padrao: {
      title: 'Visão Geral - Aluguel',
      listRoute: '/aluguel/requisicoes',
      actionRoute: '/aluguel/requisicoes',
      emptyMessage: 'Nenhum registro pendente no momento!',
      columns: [
        'OS',
        'Contrato',
        'Cliente',
        'Tipo',
        'Data de Criação',
        'Prazo',
      ],
      tableKey: 'pending_orders',
      cards: [
        {
          key: 'not_attended_orders',
          title: 'Requisições Não Atendidas',
          icon: faClipboardList,
          color: 'warning',
        },
      ],
    },

    // 2. Visão SAC (Foco em atendimento e clientes)
    sac: {
      title: 'Atendimento ao Cliente (SAC)',
      listRoute: '/aluguel/requisicoes',
      emptyMessage: 'Nenhuma pendência de cliente no momento!',
      columns: ['OS', 'Cliente', 'Status', 'Prazo'],
      tableKey: 'pending_orders_sac', // O backend deve retornar essa chave
      cards: [
        {
          key: 'not_attended_orders',
          title: 'Requisições Pendentes',
          icon: faClipboardList,
          color: 'warning',
        },
        {
          key: 'pending_customers',
          title: 'Clientes com Pendências',
          icon: faUsers,
          color: 'info',
        },
      ],
    },

    // 3. Visão Logística (Requisições em aberto e movimentos pendentes)
    logistica: {
      title: 'Requisições em aberto',
      listRoute: '/aluguel/requisicoes',
      actionRoute: '/aluguel/requisicoes',
      emptyMessage: 'Nenhuma requisição encontrada.',
      columns: [
        'Requisição',
        'Cliente',
        'Pedido / Previsão',
        'Itens enviados',
        'Situação',
      ],
      tableKey: 'logistics_requests',
      cards: [
        {
          key: 'open_requests',
          title: 'Requisições em aberto',
          icon: faClipboardList,
          color: 'primary',
        },
        {
          key: 'late_requests',
          title: 'Requisições atrasadas',
          icon: faExclamationTriangle,
          color: 'danger',
        },
        {
          key: 'pending_movements',
          title: 'Movimentos pendentes',
          icon: faDolly,
          color: 'warning',
        },
      ],
    },

    // 4. Visão Expedição (Foco em movimentos e carregamentos)
    expedicao: {
      title: 'Listagem de Movimentos',
      listRoute: '/aluguel/movimentos',
      actionRoute: '/aluguel/carregamentos',
      emptyMessage: 'Nenhum movimento pendente no momento!',
      columns: [
        'Movimento',
        'OS',
        'Cliente',
        'Tipo',
        'Data de Criação',
        'Prazo',
        'Situação',
      ],
      tableKey: 'pending_movements',
      cards: [
        {
          key: 'pending_movements',
          title: 'Movimentos Pendentes',
          icon: faDolly,
          color: 'info',
        },
        {
          key: 'pending_shipments',
          title: 'Carregamentos a Confirmar',
          icon: faTruck,
          color: 'danger',
        },
      ],
    },

    // 5. Visão Licitação (Foco em contratos)
    licitacao: {
      title: 'Contratos',
      listRoute: '/aluguel/contratos',
      emptyMessage: 'Nenhum contrato encontrado.',
      columns: ['Contrato', 'Cliente', 'Status'],
      tableKey: 'pending_contracts',
      cards: [
        {
          key: 'contracts_without_balance',
          title: 'Contratos sem saldo',
          icon: faFileContract,
          color: 'danger',
        },
        {
          key: 'contracts_expiring_soon',
          title: 'Próximos ao vencimento (30 dias)',
          icon: faClock,
          color: 'info',
        },
        {
          key: 'contracts_expired',
          title: 'Contratos vencidos',
          icon: faExclamationTriangle,
          color: 'danger',
        },
      ],
    },

    // 5. Visão Financeiro (Foco em faturamento)
    financeiro: {
      title: 'Faturamento',
      listRoute: '/faturamento/faturar',
      emptyMessage: 'Nenhum faturamento encontrado.',
      columns: ['Número', 'Cliente', 'Valor', 'Aprovado?'],
      tableKey: 'pending_invoices',
      cards: [
        {
          key: 'pending_billings',
          title: 'Faturamentos pendentes',
          icon: faFileInvoice,
          color: 'warning',
        },
        {
          key: 'approved_billings',
          title: 'Faturamentos aprovados',
          icon: faFileInvoice,
          color: 'success',
        },
      ],
    },

    // 6. Visão Direção (Foco executivo / KPIs)
    direcao: {
      title: 'Painel de decisões administrativas',
      listRoute: '/aluguel/requisicoes',
      emptyMessage: 'Nenhuma aprovação pendente.',
      columns: ['Equipamento', 'Aprovação'],
      tableKey: 'administrative_approvals',
      cards: [
        {
          key: 'pending_exchanges',
          title: 'Excedentes de contrato pendentes',
          icon: faClipboardList,
          color: 'warning',
        },
        {
          key: 'pending_upgrades',
          title: 'Upgrades/downgrades pendentes',
          icon: faTools,
          color: 'info',
        },
      ],
    },
  },
}
